import { createRgFormDataAPI } from '~/api/core/rgRequest';
import { sendErrorService } from '~/services/error';

const DEFAULTS = {
  keys: '[]',
  key_values: '{}',
  lookup: '{}',
  override_lookup: '{}',
};

const getCreativesAPI = createRgFormDataAPI('/get_creatives');

export default function getCreatives(payload) {
  return getCreativesAPI.post({ ...DEFAULTS, ...payload })
    .then(({ data }) => data.map(({
      id,
      markedup,
      subbed,
      template,
    }) => ({
      id,
      markedup,
      subbed,
      template,
    })))
    .catch((error) => {
      sendErrorService(new Error(error.data), 'get-creatives', { payload, ...DEFAULTS });

      return Promise.reject(error);
    });
}
